export default "__VITE_ASSET__C5Amfo_S__"